// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors, ProgressBar, Typography } from '@zapier/design-system';
import {
  abbreviateNumber,
  isolateComponent,
  labelStyles,
} from '@zapier/common-utils';

/** @jsx isolateComponent */

export type Props = {|
  /**
   * What the `UsageBar` is measuring.
   */
  label: string,
  /**
   * How much can be used.
   */
  max: number,
  /**
   * How much has been used.
   */
  value: number,
|};

const Styles = labelStyles(__filename, {
  text: {
    display: 'grid',
    gap: 20,
    gridTemplateColumns: 'auto 1fr',
    marginBottom: 5,
  },
  label: {
    ...Typography.base,
    fontSize: 10,
    lineHeight: '20px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: Colors.grey700,
  },
  amounts: {
    ...Typography.base,
    fontSize: 12,
    lineHeight: '20px',
    fontWeight: 600,
    textAlign: 'right',
    color: Colors.grey500,
  },
});

const formatNumber = (number: number): string => {
  const formatted =
    number > 9999 ? abbreviateNumber(number) : number.toLocaleString();
  return typeof formatted === 'string' ? formatted : 'Error';
};

/**
 * Renders a `ProgressBar` for usage with labels.
 */
const UsageBar = (props: Props) => {
  const amount =
    props.max === Infinity
      ? 'Unlimited'
      : `${formatNumber(props.value)} / ${formatNumber(props.max)}`;
  return (
    <figure>
      <p
        aria-label={`Used ${props.value} of ${props.max} ${props.label}`}
        css={Styles.text}
      >
        <span aria-hidden={true} css={Styles.label}>
          {props.label}
        </span>
        <span aria-hidden={true} css={Styles.amounts}>
          {amount}
        </span>
      </p>
      {props.max !== Infinity && (
        <ProgressBar max={props.max} value={props.value} />
      )}
    </figure>
  );
};

export default UsageBar;
